/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// ============================================
// MOONLIGHT CONCEPT — FREE SHIPPING BAR
// ============================================
(function() {
  var THRESHOLD = 250000; // 2500 QAR in cents

  function applyCountryClass(country) {
    if (country !== 'QA') {
      document.body.classList.add('mlc-show-shipping-bar');
    } else {
      document.body.classList.remove('mlc-show-shipping-bar');
    }
  }

  var cached = sessionStorage.getItem('mlc_country');
  if (cached) {
    applyCountryClass(cached);
  } else {
    fetch('https://ipapi.co/country/')
      .then(function(r) { return r.text(); })
      .then(function(country) {
        var c = country.trim();
        sessionStorage.setItem('mlc_country', c);
        applyCountryClass(c);
      })
      .catch(function() {
        sessionStorage.setItem('mlc_country', 'XX');
        applyCountryClass('XX');
      });
  }
})();